export const SINGLE_SIGNON_MODALS = {
  O365: 'singleSignOnO365',
  GOOGLE: 'singleSignOnGoogle',
  OKTA: 'singleSignOnOkta',
  DEFAULT: 'singleSignOn'
};
